import React from 'react';

class ChunkErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError(error) {
    // Only show refresh for chunk load errors
    if (
      error.name === 'ChunkLoadError' ||
      error.message.includes('Failed to fetch dynamically imported module')
    ) {
      return { hasError: true };
    }
    return { hasError: false };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div>
          <p>Fallo al cargar, por favor actualiza la página.</p>
          <button onClick={() => window.location.reload()}>Actualizar página</button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ChunkErrorBoundary;
